import { render, staticRenderFns } from "./CardView.vue?vue&type=template&id=b508ce5c&scoped=true"
import script from "./CardView.vue?vue&type=script&lang=js"
export * from "./CardView.vue?vue&type=script&lang=js"
import style0 from "./CardView.vue?vue&type=style&index=0&id=b508ce5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b508ce5c",
  null
  
)

export default component.exports